import axios from 'axios';

import { getClientParams } from '../utils/params';

// Create axios instance with baseURL from environment variables
const apiService = axios.create({
  baseURL: (window as any)?.ENV?.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
apiService.interceptors.request.use(
  async (config) => {
    const clientParams = await getClientParams();
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.params = {
      ...config.params,
      ...clientParams,
    };

    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor for handling errors
apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle authorization errors
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default apiService;
